import { useSpaceIdentifiers } from './useSpaceIdentifiers.ts';

export const useSpaceId = (spaceKey?: string): string | undefined => {
	const { spaceId } = useSpaceIdentifiers(spaceKey);
	return spaceId;
};
